import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.constitution');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-constitution',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.constitution/view.scss */
:host {
  display: block;
  height: 100%;
}

.balance-visual-grid {
  display: grid;
  gap: 16px;
  grid-template-columns: 1fr;
  min-height: 0;
}

.balance-card {
  overflow: visible;
}

.radar-panel {
  align-items: center;
  background: var(--th-surface-soft);
  border: 1px solid var(--th-line);
  border-radius: 12px;
  display: flex;
  justify-content: center;
  min-height: 360px;
  overflow: visible;
  padding: 18px;
}

.radar-chart {
  height: clamp(300px, 78vw, 340px);
  max-height: none;
  width: 100%;
}

.radar-grid {
  fill: none;
  stroke: var(--th-line);
  stroke-width: 1;
}

.radar-axis {
  stroke: var(--th-line);
  stroke-width: 1;
}

.radar-area {
  fill: rgba(16, 185, 129, 0.2);
  stroke: var(--th-primary);
  stroke-linejoin: round;
  stroke-width: 2.5;
}

.radar-point {
  fill: var(--th-card-bg);
  stroke: var(--th-primary);
  stroke-width: 2.5;
}

.balance-radar-list {
  display: grid;
  gap: 10px;
  grid-template-columns: 1fr;
}

.balance-radar-item {
  align-items: center;
  background: var(--th-surface-soft);
  border: 1px solid var(--th-line);
  border-radius: 10px;
  display: flex;
  gap: 10px;
  justify-content: space-between;
  min-height: 68px;
  min-width: 0;
  padding: 12px 14px;
}

.balance-radar-item > div {
  min-width: 0;
}

.balance-score {
  align-items: center;
  background: var(--th-primary-light);
  border-radius: 9999px;
  color: var(--th-primary-dark);
  display: inline-flex;
  flex-shrink: 0;
  font-size: var(--th-font-small);
  font-weight: 800;
  height: 34px;
  justify-content: center;
  width: 34px;
}

.rhythm-chart-card {
  background: var(--th-surface-soft);
  border: 1px solid var(--th-line);
  border-radius: 12px;
  padding: 12px 12px 10px;
}

.rhythm-line-chart {
  display: block;
  height: 132px;
  overflow: visible;
  width: 100%;
}

.rhythm-grid {
  stroke: var(--th-line);
  stroke-dasharray: 4 5;
  stroke-width: 1;
}

.rhythm-area {
  fill: rgba(245, 158, 11, 0.18);
}

.rhythm-line {
  fill: none;
  stroke: var(--th-accent);
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 3;
}

.rhythm-point {
  fill: var(--th-card-bg);
  stroke: var(--th-accent);
  stroke-width: 2.5;
}

.rhythm-label-row {
  color: var(--th-text-subtle);
  display: flex;
  font-size: var(--th-font-small);
  font-weight: 700;
  justify-content: space-between;
  padding: 4px 2px 0;
}

.rhythm-score-grid {
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  margin-top: 12px;
}

.rhythm-score-pill {
  background: var(--th-card-bg);
  border: 1px solid var(--th-line);
  border-radius: 10px;
  color: var(--th-text-subtle);
  display: grid;
  gap: 3px;
  min-width: 0;
  padding: 8px 6px;
  text-align: center;
}

.rhythm-score-pill strong {
  color: var(--th-text);
  font-size: var(--th-font-body);
}

.care-pie-layout {
  align-items: center;
  display: grid;
  gap: 18px;
  grid-template-columns: 136px minmax(0, 1fr);
}

.care-pie {
  align-items: center;
  aspect-ratio: 1;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  padding: 13px;
}

.care-pie-center {
  align-items: center;
  background: var(--th-card-bg);
  border-radius: 50%;
  box-shadow: inset 0 0 0 1px var(--th-line);
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  text-align: center;
  width: 100%;
}

.care-pie-center strong {
  color: var(--th-text);
  font-size: 24px;
  font-weight: 800;
  line-height: 1;
}

.care-pie-center span {
  color: var(--th-text-subtle);
  font-size: var(--th-font-small);
  font-weight: 700;
  margin-top: 6px;
}

.care-segment-list {
  display: grid;
  gap: 10px;
  min-width: 0;
}

.care-segment-item {
  align-items: center;
  display: flex;
  gap: 10px;
  min-width: 0;
}

.care-dot {
  border-radius: 50%;
  flex-shrink: 0;
  height: 12px;
  width: 12px;
}

.badge-page-count {
  color: var(--th-text-subtle);
  flex-shrink: 0;
  font-size: var(--th-font-small);
  font-weight: 600;
  line-height: 1;
}

.badge-carousel {
  align-items: center;
  display: grid;
  gap: 8px;
  grid-template-columns: 36px minmax(0, 1fr) 36px;
  width: 100%;
}

.badge-arrow {
  align-items: center;
  background: var(--th-card-bg);
  border: 1px solid var(--th-line);
  border-radius: 9999px;
  color: var(--th-text-subtle);
  display: inline-flex;
  height: 36px;
  justify-content: center;
  transition: background-color 160ms ease, border-color 160ms ease, color 160ms ease, opacity 160ms ease;
  width: 36px;
}

.badge-arrow:not(:disabled):hover {
  background: var(--th-surface-soft);
  border-color: var(--th-primary-light);
  color: var(--th-primary-dark);
}

.badge-arrow:disabled {
  cursor: default;
  opacity: 0.35;
}

.badge-card-grid {
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  min-width: 0;
}

.badge-card {
  align-items: center;
  border: 1px solid transparent;
  border-radius: 8px;
  display: flex;
  font-size: var(--th-font-small);
  font-weight: 700;
  justify-content: center;
  line-height: 1.25;
  min-height: 52px;
  min-width: 0;
  overflow-wrap: anywhere;
  padding: 8px 10px;
  text-align: center;
  word-break: keep-all;
}

.badge-card-primary {
  background: var(--th-primary-light);
  color: var(--th-primary-dark);
}

.badge-card-danger {
  background: var(--th-danger-soft);
  color: var(--th-danger-text);
}

.badge-card-info {
  background: var(--th-info-soft);
  color: var(--th-info-text);
}

@media (max-width: 380px) {
  .care-pie-layout {
    grid-template-columns: 1fr;
  }
  .radar-panel {
    min-height: 324px;
    padding: 16px;
  }
  .radar-chart {
    height: clamp(288px, 78vw, 304px);
  }
  .balance-radar-item {
    min-height: 64px;
    padding: 11px 12px;
  }
  .rhythm-score-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .care-pie {
    justify-self: center;
    width: 132px;
  }
  .badge-carousel {
    gap: 6px;
    grid-template-columns: 32px minmax(0, 1fr) 32px;
  }
  .badge-arrow {
    height: 32px;
    width: 32px;
  }
  .badge-card-grid {
    gap: 6px;
  }
  .badge-card {
    min-height: 48px;
    padding: 6px 7px;
  }
}`],
})
export class PageConstitutionComponent implements OnInit {
    public theme: string = 'b';
    public data: any = this.buildProfile();
    public loading: boolean = true;
    public radarLevels: number[] = [25, 50, 75, 100];
    public lineGridLevels: number[] = [25, 50, 75];
    public badgePageIndex: any = {
        good_foods: 0,
        bad_foods: 0,
        exercise: 0
    };

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.theme = localStorage.getItem('app-theme') || 'b';
        await this.load();
        this.loading = false;
        await this.service.render();
    }

    public async load() {
        try {
            let res = await wiz.call("profile");
            if (res.code === 200 && res.data) {
                this.data = this.buildProfile(res.data);
            }
        } catch (error) {
            this.data = this.buildProfile();
        }
    }

    public goBack() {
        this.service.href('/home');
    }

    public getRadarLevelPoints(level: number): string {
        const items = this.data && Array.isArray(this.data.balanceBars) ? this.data.balanceBars : [];
        const total = Math.max(items.length, 1);
        return items.map((_: any, index: number) => {
            return `${this.getRadarX(level, index, total)},${this.getRadarY(level, index, total)}`;
        }).join(' ');
    }

    public getRadarPoints(items: any[]): string {
        if (!Array.isArray(items) || items.length === 0) {
            return '';
        }

        return items.map((item: any, index: number) => {
            return `${this.getRadarX(item.score, index, items.length)},${this.getRadarY(item.score, index, items.length)}`;
        }).join(' ');
    }

    public getRadarX(score: number, index: number, total: number): number {
        return this.getRadarCoordinate(score, index, total).x;
    }

    public getRadarY(score: number, index: number, total: number): number {
        return this.getRadarCoordinate(score, index, total).y;
    }

    public getLinePoints(items: any[]): string {
        if (!Array.isArray(items) || items.length === 0) {
            return '';
        }

        return items.map((item: any, index: number) => {
            return `${this.getLineX(index, items.length)},${this.getLineY(item.score)}`;
        }).join(' ');
    }

    public getLineAreaPoints(items: any[]): string {
        if (!Array.isArray(items) || items.length === 0) {
            return '';
        }

        const firstX = this.getLineX(0, items.length);
        const lastX = this.getLineX(items.length - 1, items.length);
        return `${firstX},104 ${this.getLinePoints(items)} ${lastX},104`;
    }

    public getLineX(index: number, total: number): number {
        if (total <= 1) {
            return 100;
        }

        return Math.round((12 + (176 / (total - 1)) * index) * 10) / 10;
    }

    public getLineY(score: number): number {
        const value = this.clampScore(score);
        return Math.round((104 - (value / 100) * 88) * 10) / 10;
    }

    public getCarePieBackground(segments: any[]): string {
        if (!Array.isArray(segments) || segments.length === 0) {
            return 'conic-gradient(var(--th-primary) 0deg 360deg)';
        }

        const total = segments.reduce((sum: number, item: any) => sum + Number(item.value || 0), 0) || 1;
        let cursor = 0;
        const stops = segments.map((segment: any) => {
            const value = Number(segment.value || 0);
            const start = cursor;
            const end = cursor + (value / total) * 360;
            cursor = end;
            return `${segment.color} ${start.toFixed(1)}deg ${end.toFixed(1)}deg`;
        });

        return `conic-gradient(${stops.join(', ')})`;
    }

    public getCarePieLead(segments: any[]): any {
        if (!Array.isArray(segments) || segments.length === 0) {
            return { label: '-', value: 0 };
        }

        return segments.reduce((best: any, item: any) => {
            return Number(item.value || 0) > Number(best.value || 0) ? item : best;
        }, segments[0]);
    }

    public getBadgePageCount(key: string): number {
        const items = this.getBadgeItems(key);
        return Math.max(1, Math.ceil(items.length / this.getBadgePageSize()));
    }

    public getVisibleBadgeItems(key: string): string[] {
        const items = this.getBadgeItems(key);
        const pageSize = this.getBadgePageSize();
        if (items.length <= pageSize) {
            return items;
        }

        const maxPage = Math.max(0, this.getBadgePageCount(key) - 1);
        const currentPage = Math.min(this.badgePageIndex[key] || 0, maxPage);
        const maxStart = Math.max(0, items.length - pageSize);
        const start = Math.min(currentPage * pageSize, maxStart);
        return items.slice(start, start + pageSize);
    }

    public async moveBadgePage(key: string, direction: number) {
        const currentPage = this.badgePageIndex[key] || 0;
        const maxPage = Math.max(0, this.getBadgePageCount(key) - 1);
        const nextPage = Math.min(maxPage, Math.max(0, currentPage + direction));

        if (nextPage === currentPage) {
            return;
        }

        this.badgePageIndex[key] = nextPage;
        await this.service.render();
    }

    private getBadgeItems(key: string): string[] {
        const items = this.data && Array.isArray(this.data[key]) ? this.data[key] : [];
        return items;
    }

    private getBadgePageSize(): number {
        return 3;
    }

    private buildProfile(overrides: any = {}) {
        const constitution = this.normalizeConstitution(overrides.user_constitution || overrides.name || '소음인');
        const visuals = this.buildVisuals(constitution);

        const profile = {
            name: '소음인(少陰人)',
            element: '수(水)',
            organ_strong: '신장(腎臟)',
            organ_weak: '비장(脾臟)',
            temperature: '한(寒) - 몸이 차가운 편',
            body_type: '체격이 작고 마른 편이며, 상체보다 하체가 발달',
            personality: '내성적이고 꼼꼼하며, 계획적인 성격',
            strengths: ['세심하고 분석적', '인내력이 강함', '책임감이 강함'],
            weaknesses: ['소화력이 약함', '추위에 약함', '체력이 부족할 수 있음'],
            good_foods: ['생강', '대추', '계피', '찹쌀', '닭고기', '양고기', '감자', '시금치'],
            bad_foods: ['수박', '배', '보리', '냉면', '아이스크림', '찬 음료'],
            exercise: ['가벼운 산책', '요가', '스트레칭', '실내 자전거'],
            lifestyle: ['몸을 따뜻하게 유지', '규칙적인 식사', '과식 금지', '충분한 수면'],
            user_constitution: constitution,
            user_name: '',
            health_score: 78,
            ...visuals,
            ...overrides,
        };

        profile.summaryCards = [
            { label: '체질 적합도', value: `${profile.health_score}점`, tone: 'primary', description: '오늘 컨디션 기준' },
            { label: '집중 관리', value: visuals.focusArea, tone: 'accent', description: '우선 체크 포인트' },
            { label: '권장 운동', value: visuals.exerciseGuide, tone: 'info', description: '무리 없이 시작' },
        ];

        return profile;
    }

    private buildVisuals(constitution: string) {
        const visualMap: any = {
            '소음인': {
                focusArea: '소화·체온',
                exerciseGuide: '20분 걷기',
                careKeywords: ['따뜻한 식사', '가벼운 산책', '규칙적 수면'],
                careSegments: [
                    { label: '체온 관리', value: 38, color: 'var(--th-primary)', description: '따뜻한 식사와 보온' },
                    { label: '소화 안정', value: 34, color: 'var(--th-accent)', description: '규칙 식사와 과식 조절' },
                    { label: '회복 리듬', value: 28, color: 'var(--th-info-text)', description: '가벼운 활동과 수면' },
                ],
                balanceBars: [
                    { label: '기력 회복', score: 82 },
                    { label: '체온 균형', score: 76 },
                    { label: '소화 안정', score: 88 },
                    { label: '스트레스 완화', score: 69 },
                ],
                dailyRhythm: [
                    { label: '아침', score: 74 },
                    { label: '점심', score: 88 },
                    { label: '저녁', score: 67 },
                    { label: '수면', score: 81 },
                ],
            },
            '소양인': {
                focusArea: '열감·수분',
                exerciseGuide: '15분 스트레칭',
                careKeywords: ['수분 보충', '자극 줄이기', '호흡 안정'],
                careSegments: [
                    { label: '열감 조절', value: 36, color: 'var(--th-primary)', description: '자극 줄이기' },
                    { label: '수분 균형', value: 34, color: 'var(--th-accent)', description: '수분 보충' },
                    { label: '정서 안정', value: 30, color: 'var(--th-info-text)', description: '호흡과 휴식' },
                ],
                balanceBars: [
                    { label: '열 조절', score: 72 },
                    { label: '활동 에너지', score: 91 },
                    { label: '수분 균형', score: 68 },
                    { label: '신장 안정', score: 64 },
                ],
                dailyRhythm: [
                    { label: '아침', score: 83 },
                    { label: '점심', score: 79 },
                    { label: '저녁', score: 63 },
                    { label: '수면', score: 70 },
                ],
            },
            '태음인': {
                focusArea: '순환·호흡',
                exerciseGuide: '25분 유산소',
                careKeywords: ['규칙 운동', '호흡 관리', '과식 주의'],
                careSegments: [
                    { label: '순환 개선', value: 40, color: 'var(--th-primary)', description: '규칙 유산소' },
                    { label: '호흡 관리', value: 31, color: 'var(--th-accent)', description: '폐 기능 보조' },
                    { label: '식사 조절', value: 29, color: 'var(--th-info-text)', description: '과식 주의' },
                ],
                balanceBars: [
                    { label: '폐 기능', score: 66 },
                    { label: '지구력', score: 90 },
                    { label: '대사 순환', score: 73 },
                    { label: '체중 관리', score: 62 },
                ],
                dailyRhythm: [
                    { label: '아침', score: 69 },
                    { label: '점심', score: 86 },
                    { label: '저녁', score: 72 },
                    { label: '수면', score: 76 },
                ],
            },
            '태양인': {
                focusArea: '간 기능·과로',
                exerciseGuide: '10분 명상',
                careKeywords: ['과로 금지', '담백한 식단', '하체 보강'],
                careSegments: [
                    { label: '과로 완화', value: 42, color: 'var(--th-primary)', description: '업무 강도 조절' },
                    { label: '간 피로 관리', value: 33, color: 'var(--th-accent)', description: '담백한 식단' },
                    { label: '하체 균형', value: 25, color: 'var(--th-info-text)', description: '가벼운 근력' },
                ],
                balanceBars: [
                    { label: '집중력', score: 90 },
                    { label: '간 피로도', score: 61 },
                    { label: '하체 균형', score: 58 },
                    { label: '심신 안정', score: 70 },
                ],
                dailyRhythm: [
                    { label: '아침', score: 87 },
                    { label: '점심', score: 80 },
                    { label: '저녁', score: 60 },
                    { label: '수면', score: 68 },
                ],
            },
        };

        return visualMap[constitution] || visualMap['소음인'];
    }

    private getRadarCoordinate(score: number, index: number, total: number): any {
        const center = 100;
        const radius = 76;
        const safeTotal = Math.max(total, 1);
        const angle = (-90 + (360 / safeTotal) * index) * Math.PI / 180;
        const distance = radius * (this.clampScore(score) / 100);

        return {
            x: Math.round((center + Math.cos(angle) * distance) * 10) / 10,
            y: Math.round((center + Math.sin(angle) * distance) * 10) / 10
        };
    }

    private clampScore(score: number): number {
        const value = Number(score) || 0;
        return Math.max(0, Math.min(100, value));
    }

    private normalizeConstitution(value: string): string {
        if (!value) return '소음인';
        if (value.includes('소양')) return '소양인';
        if (value.includes('태음')) return '태음인';
        if (value.includes('태양')) return '태양인';
        if (value.includes('소음')) return '소음인';
        return '소음인';
    }
}

export default PageConstitutionComponent;